/**
 * 全局滚动锁管理器
 *
 * 使用引用计数机制，确保多个弹窗（BottomSheet、Dialog 等）同时存在时：
 * - 第一个弹窗打开时锁定滚动
 * - 最后一个弹窗关闭时才解除锁定
 * - 某个弹窗关闭不会影响其他弹窗的锁
 *
 * iOS Safari 需要同时锁 html + body，否则橡皮筋弹性滚动仍会穿透。
 */

let globalLockCount = 0;

/**
 * 锁定页面滚动
 * 每次调用都会增加引用计数，只有第一次调用才会真正锁定
 */
export function lockScroll(): void {
  globalLockCount += 1;
  if (globalLockCount === 1) {
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  }
}

/**
 * 解锁页面滚动
 * 每次调用都会减少引用计数，只有计数归零时才会真正解锁
 */
export function unlockScroll(): void {
  globalLockCount = Math.max(0, globalLockCount - 1);
  if (globalLockCount === 0) {
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  }
}

/**
 * 强制重置滚动锁（谨慎使用）
 * 仅用于紧急情况，如页面跳转前清理残留锁
 */
export function forceUnlockScroll(): void {
  globalLockCount = 0;
  document.documentElement.style.overflow = "";
  document.body.style.overflow = "";
}

/**
 * 获取当前锁计数（调试用）
 */
export function getLockCount(): number {
  return globalLockCount;
}
